import React from "react";
import Skeleton from "@components/skeleton";
import * as S from "./dashboardStyle";
import styled from "@emotion/styled";

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

const StoreOverviewSkeleton = () => {
  return (
    <SkeletonContainer>
      {/* Financial Summary Skeleton */}
      <S.Section>
        <div
          style={{
            marginBottom: "24px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Skeleton width={20} height={20} radius={4} />
          <Skeleton width={150} height={20} radius={4} />
        </div>

        <div style={{ marginBottom: "32px" }}>
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Skeleton width={14} height={14} radius={2} />
            <Skeleton width={120} height={14} radius={2} />
          </div>
          <S.BreakdownGrid>
            {[1, 2, 3, 4].map((i) => (
              <S.BreakdownCard key={i}>
                <Skeleton width={32} height={32} radius={10} />
                <Skeleton width="60%" height={11} radius={2} />
                <Skeleton width="80%" height={24} radius={4} />
              </S.BreakdownCard>
            ))}
          </S.BreakdownGrid>
        </div>

        <div>
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Skeleton width={14} height={14} radius={2} />
            <Skeleton width={120} height={14} radius={2} />
          </div>
          <S.BreakdownGrid>
            {[1, 2, 3, 4].map((i) => (
              <S.BreakdownCard key={i}>
                <Skeleton width={32} height={32} radius={10} />
                <Skeleton width="60%" height={11} radius={2} />
                <Skeleton width="80%" height={24} radius={4} />
              </S.BreakdownCard>
            ))}
          </S.BreakdownGrid>
        </div>
      </S.Section>

      {/* Order & Product Overview Skeleton */}
      <S.TwoColumnGrid>
        <S.Section>
          <div
            style={{
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Skeleton width={20} height={20} radius={4} />
            <Skeleton width={120} height={20} radius={4} />
          </div>
          <S.StatsGrid>
            {[1, 2, 3, 4].map((i) => (
              <S.StatItem key={i}>
                <Skeleton width="40%" height={11} radius={2} />
                <Skeleton width="60%" height={24} radius={4} />
              </S.StatItem>
            ))}
          </S.StatsGrid>
        </S.Section>

        <S.Section>
          <div
            style={{
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Skeleton width={20} height={20} radius={4} />
            <Skeleton width={120} height={20} radius={4} />
          </div>
          <S.StatsGrid>
            {[1, 2, 3].map((i) => (
              <S.StatItem key={i}>
                <Skeleton width="40%" height={11} radius={2} />
                <Skeleton width="60%" height={24} radius={4} />
              </S.StatItem>
            ))}
          </S.StatsGrid>
        </S.Section>
      </S.TwoColumnGrid>

      {/* Withdrawal History Skeleton */}
      <S.Section>
        <div
          style={{
            marginBottom: "24px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Skeleton width={20} height={20} radius={4} />
          <Skeleton width={150} height={20} radius={4} />
        </div>
        <S.TableContainer>
          <div style={{ padding: "16px" }}>
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                style={{ display: "flex", gap: "20px", marginBottom: "16px" }}
              >
                <Skeleton width="25%" height={20} radius={4} />
                <Skeleton width="25%" height={20} radius={4} />
                <Skeleton width="25%" height={20} radius={4} />
                <Skeleton width="25%" height={20} radius={4} />
              </div>
            ))}
          </div>
        </S.TableContainer>
      </S.Section>
    </SkeletonContainer>
  );
};

export default StoreOverviewSkeleton;
